import { ApplicationError } from '../../core/exceptions/error';

export class UnauthorizedError extends ApplicationError {
    constructor() {
        super('Diese E-Mail-Adresse oder das eingegebene Passwort ist nicht gültig');
    }
}
